import type { Renderable } from '@tanstack/react-table'
import type { JSX, ReactNode } from 'react'
import type {
	SRT_ColumnHelper,
	SRT_DisplayColumnDef,
	SRT_GroupColumnDef,
	SRT_Row,
	SRT_RowData,
	SRT_TableInstance,
} from '../types'

import {
	createRow as _createRow,
	flexRender as _flexRender,
} from '@tanstack/react-table'

import { getAllLeafColumnDefs, getColumnId } from './column.utils'

export const flexRender = _flexRender as (
	Comp: Renderable<any>,
	props: any
) => JSX.Element | ReactNode

export function createSRTColumnHelper<
	TData extends SRT_RowData,
>(): SRT_ColumnHelper<TData> {
	return {
		accessor: (accessor, column) =>
			typeof accessor === 'function'
				? ({
						...column,
						accessorFn: accessor,
					} as any)
				: {
						...column,
						accessorKey: accessor,
					},
		display: (column) => column as SRT_DisplayColumnDef<TData>,
		group: (column) => column as SRT_GroupColumnDef<TData>,
	}
}

export const createRow = <TData extends SRT_RowData>(
	table: SRT_TableInstance<TData>,
	originalRow?: TData,
	rowIndex = -1,
	depth = 0,
	subRows?: SRT_Row<TData>[],
	parentId?: string
): SRT_Row<TData> =>
	_createRow(
		table as any,
		'srt-row-create',
		originalRow ??
			Object.assign(
				{},
				...getAllLeafColumnDefs(table.options.columns).map((col) => ({
					[getColumnId(col)]: '',
				}))
			),
		rowIndex,
		depth,
		subRows as any,
		parentId
	) as SRT_Row<TData>
